export function mapTicketFromAPI(ticket, ticketActions = []) {
    return {
        Id: ticket.id,
        Status: ticket.action?.status?.slug,
        Priority: ticket.priority,
        Title: ticket.title,
        Summary: ticket.description,
        Type: ticket.type?.name,
        TypeId: ticket.type?.id,
        Category: ticket.category?.name,
        CategoryId: ticket.category?.id,
        TicketDate: ticket.created_at,
        User: ticket.user?.username,
        UserId: ticket.user?.id,
        UserEmail: ticket.user?.email,
        AssignedTo: ticket.assigned_to?.username || null,
        Source: ticket.source,
        Verified: ticket.verified,
        SlaDeadline: ticket.sla_deadline,
        WorkType: ticket.work_type,
        TicketRate: ticket.ticket_rate,
        RankId: ticket.id,
        ActionId: ticket.action?.id,
        action: ticket.action,
        ParentActionId: ticket.action?.parent_action_id,
        ActionOptions: getActionOptions(ticket.action, ticketActions),
        UnreadMessageCount: ticket.unread_messages_count || 0
    }
}

function getActionOptions(action, ticketActions) {
    if (!action?.id || !ticketActions?.length) return []

    return ticketActions
        .filter(a => a.parent_action_id === action.id)
        .map(a => ({
            text: a.title || a.name,
            value: a.id
        }))
}

export function buildTicketPayload(ticketData) {
    return {
        id: ticketData.Id,
        title: ticketData.Title,
        description: ticketData.Summary,
        priority: ticketData.Priority,
        action_id: ticketData.ActionId,
        category: {
            id: ticketData.CategoryId,
            name: ticketData.Category
        },
        type: {
            id: ticketData.TypeId,
            name: ticketData.Type
        }
    }
}

export function getActionOptionsForTicket(ticketActionId, ticketActions) {
    if (!ticketActionId || !ticketActions?.length) return []

    const currentAction = ticketActions.find(action => action.id === ticketActionId)
    const childActions = ticketActions
        .filter(action => action.parent_action_id === ticketActionId)
        .map(action => ({ text: action.title || action.name, value: action.id }))

    if (!currentAction) return childActions

    return [
        { text: currentAction.title || currentAction.name, value: currentAction.id },
        ...childActions
    ]
}